import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import * as styles from './index.module.scss'

class HelpModal extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    showClose: PropTypes.bool,
    modalClassName: PropTypes.string,
    onClose: PropTypes.func,
  }

  static defaultProps = {
    visible: false,
    showClose: false,
    modalClassName: '',
    onClose: () => {},
  }

  handleClose = () => {
    delete this.props.onClose?.()
  }

  render() {
    const { visible, showClose, title, content, actions, err } = this.props
    const content_ = err
      ? (err.errors && err.errors.length && (
          <ul className={styles.list}>
            {err.errors.map((item, idx) => (
              <li key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </ul>
        )) ||
        (err.errors && Object.keys(err.errors).length && (
          <ul className={styles.list}>
            {Object.keys(err.errors).map((item, idx) => (
              <li
                key={idx}
                dangerouslySetInnerHTML={{ __html: err.errors[item] }}
              />
            ))}
          </ul>
        )) ||
        err.error ||
        err.exception
      : (typeof content === 'string' && (
          <div dangerouslySetInnerHTML={{ __html: content }} />
        )) ||
        content

    return (
      <Modal
        contentLabel="Modal"
        ariaHideApp={false}
        isOpen={!!visible}
        className={`${styles.Modal} ${
          this.props.modalClassName || ''
        } dialogModal`}
        style={{
          overlay: { background: 'rgba(0, 0, 0, .5)' },
        }}
        onAfterOpen={this.handleAfterOpen}
      >
        <div className="modalContent">
          {showClose && (
            // eslint-disable-next-line
            <a
              id="modal_close"
              className="modalClose"
              href="#"
              onClick={evt => {
                evt.preventDefault()
                this.handleClose()
              }}
            >
              <i />
            </a>
          )}
          {title && (
            <div id="modal_title" className={styles.title}>
              {title}
            </div>
          )}
          <div id="modal_content" className={styles.content}>
            {content_}
          </div>
          <div id="modal_buttons" className={styles.actions}>
            {actions}
          </div>
        </div>
      </Modal>
    )
  }
}

export default HelpModal
